var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIlustracaoLinkExterno(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 199 208.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fdf5e6;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #071d41;\n      }\n\n      .cls-4 {\n        fill: #1351b4;\n      }\n\n      .cls-5, .cls-6 {\n        isolation: isolate;\n      }\n\n      .cls-7 {\n        fill: url(#Gradiente_sem_nome_65);\n      }\n\n      .cls-6 {\n        mix-blend-mode: soft-light;\n      }\n\n      .cls-8 {\n        fill: #0c326f;\n      }\n\n      .cls-9 {\n        fill: url(#Gradiente_sem_nome_36);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_36",
    "data-name": "Gradiente sem nome 36",
    x1: -1255.91,
    y1: 836.42,
    x2: -1254.91,
    y2: 836.42,
    gradientTransform: "translate(249925.55 174762.03) scale(199 -208.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40e0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c5d4eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_65",
    "data-name": "Gradiente sem nome 65",
    x1: 46.05,
    y1: 46.84,
    x2: 97.28,
    y2: 46.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6a200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5a310"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tipo_1",
    "data-name": "Tipo 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty-tracado01"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fundo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sombra"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.98,1.98c-6.78,1.99-12.11,4.47-16.34,7.36-.79-.48-1.83-.39-2.51.29l-4.61,4.61c-.56.56-.72,1.36-.49,2.06-1.49,1.86-2.73,3.83-3.76,5.89-3.77-1.94-8.05-3.04-12.58-3.04-15.27-.01-27.67,12.36-27.68,27.63,0,3.76.76,7.42,2.19,10.79-.08.77-.13,1.55-.15,2.34-.05,3.51.62,6.93,1.9,10.07l-17.22,4.24c-1.09.27-1.76,1.37-1.49,2.47.12.5.43.93.85,1.21l13.22,8.78-7.58,1.87c-1.09.27-1.76,1.37-1.49,2.47.12.5.43.93.85,1.21l8.81,5.85c-6.87,1.56-14.4,4.08-22.24,9.96-46.11,34.67-12.61,111.19,44.65,99.57,22.53-4.57,31.78-18.07,40.1-34.5l8.68-9.57,6.49,7.53c.74.85,2.02.95,2.88.21.22-.19.4-.43.52-.7l18.13-39.97c1.23-.48,2.46-.95,3.71-1.4-1.02,3.21-1.9,6.47-2.78,9.72l4.51-10.34c10.81-3.78,22.33-7.03,33.28-16.31C230.21,71.3,166.57-14.07,111.98,1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.04,143.01c-1.35,0-2.45-1.1-2.45-2.45,0-1.13-.91-2.04-2.04-2.04s-2.04.91-2.04,2.04c0,1.35-1.1,2.45-2.45,2.45-1.13,0-2.04.91-2.04,2.04s.91,2.04,2.04,2.04c1.35,0,2.45,1.1,2.45,2.45,0,1.13.91,2.04,2.04,2.04s2.04-.91,2.04-2.04c0-1.35,1.1-2.45,2.45-2.45,1.13,0,2.04-.91,2.04-2.04s-.91-2.04-2.04-2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.49,158.02c-1.35,0-2.45-1.1-2.45-2.45,0-1.13-.91-2.04-2.04-2.04s-2.04.91-2.04,2.04c0,1.35-1.1,2.45-2.45,2.45-1.13,0-2.04.91-2.04,2.04s.91,2.04,2.04,2.04c1.35,0,2.45,1.1,2.45,2.45,0,1.13.91,2.04,2.04,2.04s2.04-.91,2.04-2.04c0-1.35,1.1-2.45,2.45-2.45,1.13,0,2.04-.91,2.04-2.04s-.91-2.04-2.04-2.04Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cor"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M111.98,1.98c-38.48,11.32-30.76,38.17-35.07,67.92-5.37,37.14-28.59,18.09-55.26,38.15-46.11,34.67-12.61,111.19,44.65,99.57,30.41-6.17,36.62-28.59,49.02-52.54,16.04-30.99,42.64-22.54,66.51-42.76C230.21,71.3,166.57-14.07,111.98,1.98Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sombra-2",
    "data-name": "sombra"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_618",
    "data-name": "Caminho 618",
    className: "cls-6",
    d: "M87.87,172.82c-.83-.76-2.12-.7-2.88.14,0,0,0,0,0,0l-22.31,24.59c-.76.83-.69,2.12.14,2.88s2.12.69,2.88-.14l22.31-24.59c.75-.83.69-2.12-.14-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_619",
    "data-name": "Caminho 619",
    className: "cls-6",
    d: "M64.73,138.37c-.83-.76-2.12-.69-2.88.14,0,0,0,0,0,0l-37.84,41.71c-.76.83-.69,2.12.14,2.88.83.76,2.12.69,2.88-.14l37.84-41.71c.76-.83.69-2.12-.14-2.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_620",
    "data-name": "Caminho 620",
    className: "cls-6",
    d: "M58.17,156.35l-4.37,4.82c-.76.83-.69,2.12.14,2.88s2.12.69,2.88-.14l4.37-4.82c.76-.83.69-2.12-.14-2.88s-2.12-.69-2.88.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_621",
    "data-name": "Caminho 621",
    className: "cls-6",
    d: "M29.03,126.34c.58,0,1.12-.24,1.51-.67l4.37-4.81c.76-.83.69-2.12-.14-2.88s-2.12-.69-2.88.14h0l-4.37,4.81c-.76.83-.7,2.12.14,2.88.38.34.86.53,1.37.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_622",
    "data-name": "Caminho 622",
    className: "cls-6",
    d: "M174.01,54.48l-76.73,18.91v-12.71c.21-14.15-11.09-25.78-25.23-25.99-14.15-.21-25.78,11.09-25.99,25.23-.14,9.48,4.96,18.26,13.27,22.83l-23.6,5.82c-1.09.27-1.76,1.37-1.49,2.47.12.5.43.93.85,1.21l22.53,14.97-20.32,22.4c-.76.83-.69,2.12.14,2.88.83.76,2.12.69,2.88-.14l20.74-22.86,10.62,7.05.07-.04-.07.31,6.23,43.27c.16,1.11,1.19,1.89,2.31,1.73.47-.07.91-.3,1.23-.66l16.12-17.96,14.85,17.25-30.78,33.93c-.76.83-.69,2.12.14,2.88.83.76,2.12.69,2.88-.14l30.44-33.56,6.49,7.54c.74.85,2.02.95,2.88.21.22-.19.4-.43.52-.7l51.39-113.3c.47-1.03.01-2.23-1.01-2.7-.42-.19-.89-.23-1.33-.12h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "objeto"
  }, /*#__PURE__*/React.createElement("g", {
    id: "objeto02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cor-2",
    "data-name": "cor",
    className: "cls-8",
    d: "M178.09,40.02l-103.84,51.11-2.59,12.23,6.85,47.59,99.58-110.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-3",
    "data-name": "cor",
    className: "cls-6",
    d: "M87.76,118.38l-9.25,32.57,19.04-21.2-9.78-11.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-4",
    "data-name": "cor",
    className: "cls-4",
    d: "M178.09,40.02l-54.44,120.04-35.89-41.67,90.33-78.37Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "objeto-2",
    "data-name": "objeto"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_212",
    "data-name": "Grupo 212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_626",
    "data-name": "Caminho 626",
    className: "cls-2",
    d: "M116.26,127.8c-.85.74-2.14.65-2.88-.2l-15.62-17.89,3.08-2.67,15.62,17.88c.74.85.66,2.14-.19,2.88,0,0,0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_213",
    "data-name": "Grupo 213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_627",
    "data-name": "Caminho 627",
    className: "cls-2",
    d: "M122.61,121c-.85.74-2.14.65-2.88-.2l-14.98-17.16,3.08-2.68,14.98,17.15c.74.85.66,2.14-.19,2.88,0,0,0,0,0,0h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_214",
    "data-name": "Grupo 214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_628",
    "data-name": "Caminho 628",
    className: "cls-2",
    d: "M128.96,114.21c-.85.74-2.14.66-2.88-.19,0,0,0,0,0,0l-14.34-16.43,3.08-2.68,14.34,16.42c.74.85.65,2.14-.2,2.88h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_215",
    "data-name": "Grupo 215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_629",
    "data-name": "Caminho 629",
    className: "cls-2",
    d: "M135.31,107.41c-.85.74-2.14.65-2.88-.2l-13.7-15.69,3.08-2.67,13.7,15.68c.74.85.65,2.14-.2,2.88h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_216",
    "data-name": "Grupo 216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_630",
    "data-name": "Caminho 630",
    className: "cls-2",
    d: "M141.66,100.61c-.85.74-2.13.65-2.87-.2,0,0,0,0,0,0l-13.07-14.96,3.08-2.68,13.06,14.95c.74.85.65,2.14-.2,2.88h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_217",
    "data-name": "Grupo 217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_631",
    "data-name": "Caminho 631",
    className: "cls-2",
    d: "M145.43,79.82c-.85.74-2.14.65-2.88-.2l-4.36-4.99,3.08-2.68,4.36,4.99c.74.85.65,2.14-.2,2.88h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "cor-5",
    "data-name": "cor",
    className: "cls-4",
    d: "M71.66,103.09l106.43-63.07L31.22,76.21l40.44,26.88Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "objeto01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cor-6",
    "data-name": "cor",
    className: "cls-7",
    d: "M94.07,72.45h-22.4c-14.15,0-25.62-11.47-25.62-25.62,0-14.15,11.47-25.62,25.62-25.62s25.62,11.47,25.62,25.62h0v22.4c0,1.77-1.43,3.21-3.21,3.22h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "objetos"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_50",
    "data-name": "Elipse 50",
    className: "cls-2",
    cx: 83.38,
    cy: 46.84,
    r: 3.81
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_51",
    "data-name": "Elipse 51",
    className: "cls-2",
    cx: 71.66,
    cy: 46.84,
    r: 3.81
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_52",
    "data-name": "Elipse 52",
    className: "cls-2",
    cx: 59.94,
    cy: 46.84,
    r: 3.81
  })))), /*#__PURE__*/React.createElement("g", {
    id: "padroes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_635",
    "data-name": "Caminho 635",
    className: "cls-4",
    d: "M118.73,36.49c-1.13,0-2.04-.91-2.04-2.04h0c0-1.35-1.1-2.45-2.45-2.45-1.13,0-2.04-.91-2.04-2.04,0-1.12.91-2.04,2.04-2.04,1.35,0,2.45-1.1,2.45-2.45,0-1.13.91-2.04,2.04-2.04s2.04.91,2.04,2.04c0,1.35,1.1,2.45,2.45,2.45,1.13,0,2.04.91,2.04,2.04,0,1.13-.91,2.04-2.04,2.04h0c-1.35,0-2.45,1.1-2.45,2.45,0,1.13-.91,2.04-2.04,2.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_636",
    "data-name": "Caminho 636",
    className: "cls-4",
    d: "M159.55,151.58c-1.13,0-2.04-.91-2.04-2.04h0c0-1.35-1.1-2.45-2.45-2.45-1.13,0-2.04-.91-2.04-2.04s.91-2.04,2.04-2.04c1.35,0,2.45-1.1,2.45-2.45,0-1.13.91-2.04,2.04-2.04s2.04.91,2.04,2.04c0,1.35,1.1,2.45,2.45,2.45,1.13,0,2.04.91,2.04,2.04s-.91,2.04-2.04,2.04c-1.35,0-2.45,1.1-2.45,2.45,0,1.13-.91,2.04-2.04,2.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_637",
    "data-name": "Caminho 637",
    className: "cls-3",
    d: "M148,166.58c-1.13,0-2.04-.91-2.04-2.04h0c0-1.35-1.1-2.45-2.45-2.45-1.13,0-2.04-.91-2.04-2.04s.91-2.04,2.04-2.04c1.35,0,2.45-1.1,2.45-2.45,0-1.13.91-2.04,2.04-2.04s2.04.91,2.04,2.04c0,1.35,1.1,2.45,2.45,2.45,1.13,0,2.04.91,2.04,2.04s-.91,2.04-2.04,2.04c-1.35,0-2.45,1.1-2.45,2.45,0,1.13-.91,2.04-2.04,2.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_638",
    "data-name": "Caminho 638",
    className: "cls-2",
    d: "M25.52,143.03c-.54,0-1.06-.22-1.44-.6l-4.61-4.61c-.8-.8-.8-2.09,0-2.88l4.61-4.61c.8-.8,2.09-.8,2.88,0l4.61,4.61c.8.8.8,2.09,0,2.88,0,0,0,0,0,0l-4.61,4.61c-.38.38-.9.6-1.44.6ZM23.79,136.38l1.73,1.73,1.73-1.73-1.73-1.73-1.73,1.73Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustracaoLinkExterno);
export default __webpack_public_path__ + "static/media/ilustracao-link-externo.ed8aafbb1051101a0f398317f8fe7c8a.svg";
export { ForwardRef as ReactComponent };